import { useClientCountry } from "../i18n/ClientCountryProvider"
import { Globe } from "lucide-react"
import { useCountrySelectionModal } from "../providers/CountrySelectionModalProvider"

const CountrySelector = () => {
    const { currentCountryData } = useClientCountry()
    const { openModal } = useCountrySelectionModal()

    return (
        <>
            {
                currentCountryData && (
                    <button
                        className="flex items-center text-sm text-muted-foreground cursor-pointer hover:text-foreground transition-colors"
                        onClick={openModal}
                        aria-label="Seleccionar país"
                    >
                        <Globe className="w-4 h-4 mr-1" />
                        <span>{currentCountryData.name || "Selecciona un país"}</span>
                    </button>
                )
            }
        </>
    )
}

export default CountrySelector;